import React from 'react';
import './InFlightMobile.css';

const InFlightMobile = ({ flightData, onFlightClick }) => {
    if (!flightData || flightData.length === 0) {
        return (
            <div className="inflight-mobile-wrapper">
                <div className="no-flights-mobile">
                    <p>No flights currently in progress</p>
                </div>
            </div>
        );
    }

    return (
        <div className="inflight-mobile-wrapper">
            {flightData.map((flight, index) => (
                <div 
                    key={flight.id} 
                    className="flight-card"
                    onClick={() => onFlightClick && onFlightClick(index, flight)}
                >
                    {/* Callsign/Flight Number */}
                    <div className="card-callsign">
                        ❖ {flight.user}
                    </div>
                    
                    {/* Aircraft */}
                    <div className="card-aircraft">
                        {flight.eqpt}
                    </div>
                    
                    {/* Flight Details Section 1 */}
                    <div className="card-data-section">
                        <div className="card-header-row">
                            <div className="card-header">ORIG</div>
                            <div className="card-header">DEST</div>
                            <div className="card-header">KTS</div>
                            <div className="card-header">MSL</div>
                        </div>
                        <div className="card-data-row">
                            <div className="card-data">{flight.orig}</div>
                            <div className="card-data">{flight.dest}</div>
                            <div className="card-data">{flight.spd}</div>
                            <div className="card-data">{flight.alt}</div>
                        </div>
                    </div>
                    
                    {/* Flight Details Section 2 */}
                    <div className="card-data-section">
                        <div className="card-header-row">
                            <div className="card-header">NM</div>
                            <div className="card-header">DTG</div>
                            <div className="card-header">TTG</div>
                            <div className="card-header">ETA</div>
                        </div>
                        <div className="card-data-row">
                            <div className="card-data">{flight.dtr}</div>
                            <div className="card-data">{flight.dtg}</div>
                            <div className="card-data">{flight.ttg}</div>
                            <div className="card-data">
                                {flight.eta === 'Arrived' 
                                    ? '...' 
                                    : flight.eta.substring(0, 5)
                                }
                            </div>
                        </div>
                    </div>
                </div>
            ))}
        </div>
    );
};

export default InFlightMobile;
